export default __webpack_public_path__ + "static/media/480_store04-jp-mobile.ad8dd3a6.png";